export default __webpack_public_path__ + "static/media/male.8d1adce0.svg";